import React from 'react';
import './PrintData.css';
import Logo from "../../Images/Logo.png";
import { timerDifference } from "../../App";
import { formatMoney } from "../../App";

class PrintData extends React.Component {

    renderTableChunk = (dataChunk, startIndex, totalChunks, rowsPerPage) => {
        const { printTableData, HeadingButton, type } = this.props;
        const representativePrintData = HeadingButton && HeadingButton.length > 0 ? HeadingButton[0] : null;
        const totalPages = Math.ceil(totalChunks / rowsPerPage);
        const currentPage = Math.ceil(startIndex / rowsPerPage) + 1;

        return (
            <div className="printtabledata">
                <img className="tom_logo_print" src={Logo} alt="image error" />
                <div className="printDataTitle">Completed Prescriptions</div>
                <div className='kwd_vlaues_font'>All values in INR</div>
                <table>
                    <thead className="print_header">
                        <tr>
                            <th className="print_header_text" style={{ textAlign: 'center' }}>S.No</th>
                            <th className="print_header_text" style={{ textAlign: 'center' }}>ID</th>
                            <th className="print_header_text" style={{ textAlign: 'center' }}>Member</th>
                            <th className="print_header_text" style={{ textAlign: 'center' }}>Member Phone no</th>
                            <th className="print_header_text" style={{ textAlign: 'center' }}>Doctor</th>
                            <th className="print_header_text" style={{ textAlign: 'center' }}>Approval received on</th>
                            <th className="print_header_text" style={{ textAlign: 'center' }}>Delivered on</th>
                            <th className="print_header_text" style={{ textAlign: 'center' }}>Time taken</th>
                            <th className="print_header_text" style={{ textAlign: 'center' }}>Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataChunk.map((printdata, index) => (
                            <tr key={startIndex + index}>
                                <td style={{ textAlign: 'center' }}>{index + startIndex + 1}</td>
                                <td style={{ textAlign: 'center' }}>{printdata.orderId}</td>
                                <td>{printdata.customer}</td>
                                <td style={{ textAlign: 'center' }}>{printdata.phone_no}</td>
                                <td>{printdata.doctorName}</td>
                                <td style={{ textAlign: 'center' }}>{printdata.approval_received_on}</td>
                                <td style={{ textAlign: 'center' }}>{printdata.deliverd_on}</td>
                                <td style={{ textAlign: 'center' }}>{printdata.timer}</td>
                                <td style={{ textAlign: 'right' }}>{formatMoney(printdata.billed_amount)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="print_footer">
                    Page {currentPage} of {totalPages}
                </div>
                {dataChunk.length === rowsPerPage && startIndex + rowsPerPage < totalChunks && <div className="page-break"></div>}
            </div>
        );
    };

    render() {
        const rowsPerPage = 30; // Adjust this number based on your page layout and font size
        const { printtableData } = this.props;
        const totalChunks = Math.ceil(printtableData.length / rowsPerPage);

        const tableChunks = [];
        for (let i = 0; i < totalChunks; i++) {
            const startIndex = i * rowsPerPage;
            const dataChunk = printtableData.slice(startIndex, startIndex + rowsPerPage);
            tableChunks.push(this.renderTableChunk(dataChunk, startIndex, printtableData.length, rowsPerPage));
        }

        return <div>{tableChunks}</div>;
    }
}

export default PrintData;

